/**
 * XTranslatorDocIndex - Landing page for X-Translator SW documentation.
 * Shows overview and links to first topics.
 */
import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import DocSidebar from "../components/DocSidebar";

const BASE_PATH = "/docs/x-translator-sw";

export default function XTranslatorDocIndex() {
  return (
    <Layout sidebar={<DocSidebar basePath={BASE_PATH} />} showSidebar={true}>
      <article className="doc-content max-w-4xl">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 border-b border-gray-200 dark:border-gray-700 pb-4">
            SEPM X-Translator SW (Smallworld)
          </h1>
          <p className="mt-4 text-gray-600 dark:text-gray-400">
            Admin Manual — Installation and configuration of the product SEPM X-Translator for
            Smallworld.
          </p>
        </header>

        <div className="prose prose-gray dark:prose-invert max-w-none">
          <p>
            This documentation covers the installation, configuration, and API of the SEPM
            X-Translator for Smallworld. Use the sidebar to navigate through the topics.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">Quick links</h2>
          <ul>
            <li>
              <Link to={`${BASE_PATH}/1-introduction`} className="text-sepm-primary dark:text-sepm-primary-dark hover:underline">
                1 Introduction
              </Link>
            </li>
            <li>
              <Link to={`${BASE_PATH}/2-1-1-overview`} className="text-sepm-primary dark:text-sepm-primary-dark hover:underline">
                2.1.1 Overview
              </Link>
            </li>
            <li>
              <Link to={`${BASE_PATH}/2-2-1-settings`} className="text-sepm-primary dark:text-sepm-primary-dark hover:underline">
                2.2.1 Settings in x_translator_settings.magik
              </Link>
            </li>
            <li>
              <Link to={`${BASE_PATH}/5-1-1-engine`} className="text-sepm-primary dark:text-sepm-primary-dark hover:underline">
                5.1.1 X-Translator Engine
              </Link>
            </li>
            <li>
              <Link to={`${BASE_PATH}/3-2-1-checklist`} className="text-sepm-primary dark:text-sepm-primary-dark hover:underline">
                3.2.1 Checklist for Submitting a Ticket
              </Link>
            </li>
          </ul>

          <p className="mt-8 text-sm text-gray-500 dark:text-gray-500">
            Version 2026-01. © Copyright SEPM. All logos and trademarks are property of their
            respective owners.
          </p>
        </div>
      </article>
    </Layout>
  );
}
